import { Component, OnInit } from '@angular/core';
import { PlanProizvodnjeService } from './plan-proizvodnje.service';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { Router } from '@angular/router';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { moduli } from '../../config';


pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-plan-proizvodnje',
  templateUrl: './plan-proizvodnje.component.html',
  styleUrls: ['./plan-proizvodnje.component.scss'],
  providers: [PlanProizvodnjeService],
})
export class PlanProizvodnjeComponent implements OnInit {
  todayDate: Date = new Date();
  currentMonthDates: any;
  monthArr: any;
  linije: any;
  planDohvacen: boolean;
  startOfMonth: any;
  endOfMonth: any;
  line: any;
  calendarDate: any;
  popupVisible = false;
  smjenaPodaci: any;
  datum: string;
  smjena: string;

    // PRAVA KORISNIKA
    pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
    trenutniPogled: any;
    pravaZaTrenutniPogled: any;
    prikaziStranicu = 0;
    // KRAJ PRAVA KORISNIKA

  
  constructor(
    private planProizvodnjeService: PlanProizvodnjeService,
    private router: Router
  ) {
    if (parseInt(localStorage.getItem('firma')) == 3) {
      this.router.navigate(['/dostavnica-hlad']);
    }
    this.linije = [{ id: '', naziv: 'SVE' }];

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().planProizvodnjePoLinijama;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {
    this.dohvatiSveLinije();
    this.calendarDate = this.todayDate;
    this.line = 0;
    this.startOfMonth = moment(this.calendarDate)
      .startOf('month')
      .format('YYYY-MM-DD');
    this.endOfMonth = moment(this.calendarDate)
      .endOf('month')
      .format('YYYY-MM-DD');
    this.calendar(this.calendarDate);
    this.planProizvodnje(this.startOfMonth, this.endOfMonth, this.line);
  }

  calendar(date) {
    this.currentMonthDates = Array.from(
      { length: moment(date).daysInMonth() },
      (x, i) => moment(date).startOf('month').add(i, 'days')
    );
    // console.log(this.currentMonthDates);
    this.monthArr = [];
    for (let day of this.currentMonthDates) {
      this.monthArr.push({
        datum: moment(day).format('DD.MM.YYYY.'),
        dan: moment(day).locale('hr').format('dddd'),
      });
    }
    // console.log(this.monthArr);
  }

  planProizvodnje(start, end, line) {
    this.planProizvodnjeService
      .dohvatiPlanProizvodnje({
        datumod: start,
        datumdo: end,
        brojlinije: line,
      })
      .subscribe((res) => {
        console.log(res);
        this.planDohvacen = false;
        if (res.success == true) {
          this.planDohvacen = true;
          // console.log(this.planDohvacen);
          setTimeout(function () {
            // css nedjelja crvenom bojom
            var days = [].slice.call(
              document.getElementsByClassName('day-name')
            );
            for (let day of days) {
              if (day.innerHTML == 'nedjelja') {
                day.parentNode.style.background = '#E21A22';
              }
            }
            // css popunjene smjene zelenom bojom
            let dates = [].slice.call(
              document.getElementsByClassName('day-date')
            );
            // console.log(dates);
            for (let smjena of res.data) {
              for (let date of dates) {
                if (
                  moment(smjena.pp_datumsmjena).format('DD.MM.YYYY.') ==
                  date.innerHTML
                ) {
                  if (smjena.smjena_idsmjena == 1) {
                    date.parentNode.nextSibling.childNodes[0].classList.add(
                      'smjenaPopunjena'
                    );
                  }
                  if (smjena.smjena_idsmjena == 2) {
                    date.parentNode.nextSibling.childNodes[1].classList.add(
                      'smjenaPopunjena'
                    );
                  }
                  if (smjena.smjena_idsmjena == 3) {
                    date.parentNode.nextSibling.childNodes[2].classList.add(
                      'smjenaPopunjena'
                    );
                  }
                }
              }
            }
          }, 500);
        } else {
          this.planDohvacen = false;
        }
      });
  }

  otvoriPopup(d, s) {
    console.log(d + ' ' + s);
    this.datum = d;
    this.smjena = s;
    this.popupVisible = true;
    this.smjenaPodaci = [];
    let objekt = {
      datum: moment(d, 'DD.MM.YYYY.').format('YYYY-MM-DD'),
      smjena: s,
    };
    // console.log(objekt);
    this.planProizvodnjeService.pregledSmjene(objekt).subscribe((res) => {
      console.log(res);
      for (let data of res.data) {
        this.smjenaPodaci.push({
          proizvod: data.ar_naziv,
          proizvodID: data.artikl_ar_id,
          sifra: data.ar_sifra,
          linija: data.li_naziv,
          linijaID: data.pp_brojlinije,
          kolicina: data.pp_planiranakolicina,
          kartoni: data.brojkartona,
          palete: data.brojpaleta,
          idPlan: data.idplanproizvodnje,
          napomena: data.pp_napomena,
        });
      }
    });
  }

  onValueChanged(e) {
    // console.log(e.value);
    this.calendarDate = e.value;
    this.calendar(this.calendarDate);
    this.startOfMonth = moment(e.value).startOf('month').format('YYYY-MM-DD');
    this.endOfMonth = moment(e.value).endOf('month').format('YYYY-MM-DD');
    this.planProizvodnje(this.startOfMonth, this.endOfMonth, this.line);
  }

  promjenaLinije(e) {
    // console.log(e);
    this.line = e.value;
    this.calendar(this.calendarDate);
    this.planProizvodnje(this.startOfMonth, this.endOfMonth, this.line);
  }

  // DOHVAĆANJE NAZIVA LINIJA
  dohvatiSveLinije() {
    this.planProizvodnjeService.dohvatiSveLinije({}).subscribe((res) => {
      console.log(res);
      this.linije = [{ id: '', naziv: 'SVE' }];
      if (res.success == true) {
        for (let linija of res.data) {
          // console.log(linija);
          this.linije.push({
            id: linija.idlinija,
            naziv: linija.li_naziv,
          });
        }
        console.log(this.linije);
      }
    });
  }

  createPdf() {
    let hLine = {
      table: {
        widths: ['*'],
        body: [[''], ['']],
      },
      layout: {
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 0 : 1;
        },
        vLineWidth: function (i, node) {
          return 0;
        },
      },
    };

    let ct = [];
    ct.push({
      text: `Pregled proizvodnje smjena ${this.smjena} datum ${this.datum}`,
      style: 'subtitle',
      margin: [0, 0, 0, 30],
    });

    ct.push({
      table: {
        widths: [40, 210, 45, 35, 30, 70, 30],
        body: [
          [
            'Šifra',
            'Proizvod',
            { text: 'Količina', alignment: 'right' },
            { text: 'Kartona', alignment: 'right' },
            { text: 'Paleta', alignment: 'right' },
            'Linija',
            { text: 'Plan', alignment: 'center' },
          ],
        ],
      },
      layout: 'lightHorizontalLines',
    });
    ct.push(hLine);
    for (let proizvod of this.smjenaPodaci) {
      ct.push({
        table: {
          widths: [40, 210, 45, 35, 30, 70, 30],
          body: [
            [
              proizvod.sifra,
              proizvod.proizvod,
              { text: proizvod.kolicina, alignment: 'right' },
              { text: proizvod.kartoni, alignment: 'right' },
              { text: proizvod.palete, alignment: 'right' },
              proizvod.linija,
              { text: proizvod.idPlan, alignment: 'center' },
            ],
          ],
        },
        layout: 'lightHorizontalLines',
      });
      if (proizvod.napomena) {
        ct.push({
          table: {
            widths: [40, 420],
            body: [[{ text: '' }, { text: `Napomena: ${proizvod.napomena}` }]],
          },
          layout: 'lightHorizontalLines',
        });
      }
    }
    ct.push(hLine);

    var dd = {
      info: {
        title: `Smjena ${this.smjena} datum ${this.datum}`,
      },
      content: ct,
      pageMargins: 15,
      defaultStyle: {
        fontSize: 9.5,
      },
      styles: {
        mainTitle: {
          fontSize: 17,
          bold: true,
        },
        subtitle: {
          fontSize: 13,
        },
      },
    };
    pdfMake.createPdf(dd).open();
  }
}
